import React, {useCallback, useState} from "react"
import PropTypes from "prop-types"
import InputContainer from "../Layouts/InputContainer"
import InlineForm from "../Layouts/InlineForm"

export default function CustomDatesForm(props){
	const [fromDate, setFromDate] = useState("")
	const [toDate, setToDate] = useState("")
	
	const onSubmitRange = useCallback(() => {
		const enteredFromDate = fromDate
		const enteredToDate = toDate
		
		props.onSubmitCallback(enteredFromDate, enteredToDate)
	}, [fromDate, toDate, props.onSubmitCallback])
	
	return <InlineForm>
		<InputContainer title={"From Date:"}>
			<input
				value={fromDate}
				onChange={(e) => setFromDate(e.target.value)}
			/>
		</InputContainer>
		<InputContainer title={"To Date:"}>
			<input
				value={toDate}
				onChange={(e) => setToDate(e.target.value)}
			/>
		</InputContainer>
		<button
			type={"button"}
			onClick={onSubmitRange}
			children={"Set Dates"}
		/>
	</InlineForm>
}

CustomDatesForm.propTypes = {
	onSubmitCallback: PropTypes.func.isRequired
}